import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root',
})
export class RitwikTransmissionService extends ApiService {
  public getRitwikList(id: any): Observable<any> {
    return this.get<any>(
      this.replacePathInfo(ROUTES.RITWIK_LIST, {
        id: id,
      })
    );
  }

  public getRitwikListV2(id: any): Observable<any> {
    return this.get<any>(
      this.replacePathInfo(ROUTES.RITWIK_LIST_V2, {
        id: id,
      })
    );
  }

  public getWorkerList(id: any): Observable<any> {
    return this.get<any>(
      this.replacePathInfo(ROUTES.ALL_WORKER_LIST, {
        id: id,
      })
    );
  }

  public getWorkerNameFc(reqBody: any): Observable<any> {
    return this.get<any>(ROUTES.WORKER_NAME_FC, {
      params: reqBody,
    });
  }
}
